import React from "react";
import "./PillTag.scss";
import PropTypes from "prop-types";

const PillTag = ({ label, color }) => {
  return <div className={`pill_tag ${color}`}>{label}</div>;
};

PillTag.propTypes = {
  label: String,
  color: PropTypes.oneOf(['pink','green','blue']),
};

export default PillTag;
